<template>
    <div>
        <div>
            <div class="bs-component d-inline-flex">
                <div class="btn-group">
                    <mmf-button type="downloadFile"
                                v-bind:class="'btn btn-outline-primary btn-sm mb-2'"
                                v-on:click="downloadFile">
                    </mmf-button>
                    <mmf-button type="uploadFile"
                                v-bind:class="'btn btn-outline-primary btn-sm mb-2'"
                                v-on:click="uploadFile">
                    </mmf-button>
                </div>
                <div class="ml-2">
                    <mmf-button type="add"
                                v-bind:class="'btn btn-outline-primary btn-sm mb-2'"
                                v-on:click="addRow">
                    </mmf-button>
                </div>
            </div>
            <table class="table table-striped table-hover">
                <thead>
                <tr>
                    <th v-for="col in tableColumns" v-bind:key="col.key" :class="{'actions-column': col.form.type == 'actions'}">
                        <div scope="col">
                            {{ $t(col.label) }}
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in rows" v-bind:key="index">
                        <td v-for="col in tableColumns" v-bind:key="col.key">
                            <div v-if="col.form.type == 'actions'">
                                <div v-if="isRowEditing(row)">
                                        <mmf-button type="check"
                                                    v-bind:class="'btn btn-outline-secondary btn-sm border-0'"
                                                    v-on:click="saveChangesOnRow(row)">
                                        </mmf-button>
                                        <mmf-button type="cancel"
                                                    v-bind:class="'btn btn-outline-secondary btn-sm border-0'"
                                                    v-on:click="cancelNewRow(row)">
                                        </mmf-button>
                                </div>
                                <div id="editDelActions" v-else>
                                    <template>
                                        <mmf-button type="edit"
                                                    v-bind:class="'btn btn-outline-secondary btn-sm border-0'"
                                                    v-on:click="editRow(row)">
                                        </mmf-button>
                                        <mmf-button type="delete"
                                                    v-bind:class="'btn btn-outline-secondary btn-sm border-0'"
                                                    v-on:click="delRow(row)">
                                        </mmf-button>
                                    </template>
                                </div>
                            </div>
                            <div v-else>
                                <mmf-form-helper :metadata="col" 
                                                 :isEditing="isRowEditing(row)"
                                                 :value="row[col.key]"
                                                 @input="changeEntityAttribute(col, row, $event)">
                                </mmf-form-helper>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <mmf-upload-modal v-if="isVisible"
                              v-on:confirm="setTableRows($event)">
            </mmf-upload-modal>
        </div>
    </div>
</template>


<script>
import MmfButton from "@/components/MmfButton";
import MmfNoResultAlert from "@/components/MmfNoResultAlert";
import MmfPagination from "@/components/MmfPagination";
import MmfFormHelper from "@/components/MmfFormHelper";
import MmfUploadModal from "@/components/MmfUploadModal";


import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import model from '@/model/index' 

let checkboxField = {
    key: 'state',
    label: 'state',
    isControlField: true,
    form: {
        type: 'checkbox'
    }
};

let actionField = {
    key: 'actions',
    label: '',
    isActionField: true,
    form: {
        type: 'actions'
    }
};

const editModeKey = 'inEditMode'

export default {
    name: 'mmf-edit-table',
    data() {
        return {
            modalEditValue: "",
            modelEditColumnLabel: "",
            modelEditColumnKey: "",
            modelEditMode: {},
            modalEditRow: null,
            tempId: -1
        }
    },
    components: { MmfButton, MmfNoResultAlert, MmfPagination, MmfFormHelper, MmfUploadModal },
    props: {
        entity: {
            type: String,
            required: true
        },
        attributeEntity: {
            type: String,
            required: true
        },
        attributeKey: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapState({
            isVisible: state => state.uploadModal.isVisible
        }),
        tableColumns() {
            let gridFields = model[this.attributeEntity].gridFields();
            let entityData = [];
            entityData = entityData.concat(gridFields);
            entityData.push(actionField);
            return entityData;
        },
        rows: {
            get () {
                var result = this.$store.state[this.entity].entity[this.attributeKey]
                return result
            }
        },
        baseUrl: {
            get () {
                var result = this.$store.state[this.entity].baseModuleUrl
                return result
            }
        },
        newEntity() {
            return model[this.attributeEntity].newEntity();
        }
    },
    methods: {
        toggleAll(checked) {
            if(!checked){
                this.$store.commit(this.entity + "/setCheckedItems", [] );
                return;
            }

            var auxVector = []
            for (let i in this.$store.state[this.entity].rows)
                auxVector.push(this.$store.state[this.entity].rows[i].id)

            this.$store.commit(this.entity + "/setCheckedItems", auxVector);
        },
        saveChangesOnRow(row) {
            var newRow =  model[this.attributeEntity].newEntity();
            var newObject = {}
            Object.assign(newObject, row);
            delete newObject.rowState;
            delete newRow.rowState;
            var isEqual = JSON.stringify(newObject) == JSON.stringify(newRow)
            if (!isEqual)
                this.$store.commit(this.entity + "/changeAttributeRowState", {entityAttributeKey: this.attributeKey, row: row, changes: { 'inEditMode': false }});
        },
        cancelRowEdit(row) {
            this.$store.commit(this.entity + "/changeAttributeRowState", {entityAttributeKey: this.attributeKey, row: row, changes: { 'inEditMode': false }});
        },
        editRow(row) {
            this.$store.commit(this.entity + "/changeAttributeRowState", {entityAttributeKey: this.attributeKey, row: row, changes: { 'inEditMode': true }});
        },
        delRow(row) {
            var modifiedRows = this.rows.filter(x => x.id !== row.id);
            this.$store.commit(this.entity + "/setRows", modifiedRows);
        },
        addRow() {
            var newRow =  model[this.attributeEntity].newEntity();
            newRow.rowState.inEditMode = true
            newRow.rowState["tempId"] = this.tempId
            this.tempId = this.tempId - 1
            this.$store.commit(this.entity + "/addAttributeRow", {entityAttributeKey: this.attributeKey, row: newRow});
        },
        uploadFile() {
            this.$modal.uploadModal()
        },
        downloadFile(row) {
          var url = this.baseUrl + "/" + this.entity + "/download";
          this.$store.dispatch("api/postNewPageDownload",{ url , data: this.rows});          
        },
        cancelNewRow(row) {
            // TODO
            this.$store.commit(this.entity + "/removeAttributeRow", {entityAttributeKey: this.attributeKey, row: row})
        },
        changeEntityAttribute(col, row, $event) {
            this.$store.commit(this.entity + "/setAttributeRow", {entityAttributeKey: this.attributeKey, row: row, key: col.key, newValue: $event});
        },
        isRowEditing(row) {
            return row.rowState ? row.rowState.inEditMode : false;
        },
        isChecked(row) {
            return row.rowState.isChecked;
        },
        setTableRows(newRows) {
            for (var i=0; i < newRows.length; i++){
                newRows[i]['rowState'] = {inEditMode: false, isChecked: false}
            } 
            if (this.rows){
                this.$store.commit(this.entity + "/setAttributeRows", {entityAttributeKey: this.attributeKey, rows: newRows})
            }
        },
        ...mapActions("base", ["MMFselectRow", "MMFSaveInline", "MMFEdit", "MMFExport"])
        }
}
</script>
